import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/cotton/"

const baseApi = () => {
  function playerLogin(data) {
      return Post(baseUrl + "playerLogin", data)
  }

    function loginByPhone(data) {
        return Post(baseUrl + "loginByPhone", data)
    }

    function loginByEmail(data) {
        return Post(baseUrl + 'web/loginByEmail', data);
    }

    function registerByEmail(data) {
        return Post(baseUrl + 'web/registerByEmail', data);
    }

    function registerAccountByPhoneOrEmail(data) {
        return Post(baseUrl + 'register', data);
    }

    {
        return {
            playerLogin,
            loginByPhone,
            loginByEmail,
            registerByEmail,
            registerAccountByPhoneOrEmail
        }
    }
}

export const loginApi = baseApi()
